export const IMAGE = {
    logo : require("./Image/logo.png")
}